import BasicProduction from "@/views/open_queries/producer/BasicProduction.vue";

export default [
  {
    path: "/oq/producer/basic_production/:producer_id/:crop_id",
    name: "oq_producer_basic_production_path",
    component: BasicProduction,
    props: true,
  },
];
